import React from "react";

const Button = ({
  color = "blue",
  maxWidth = "fit",
  className = "",
  children,
  ...props
}) => {
  const colors = {
    blue: "bg-blue-700 hover:bg-blue-600",
    green: "bg-lime-700 hover:bg-lime-600",
    nycgreen: "bg-nyc-green hover:bg-nyc-green-hover",
  };

  const maxWidths = {
    fit: "max-w-fit",
    next: "w-full max-w-32",
    sm: "w-full max-w-xs",
    md: "w-full max-w-sm",
    lg: "w-full max-w-md",
    full: "w-full max-w-full",
  };

  return (
    <button
      type="button"
      className={`px-6 py-3 text-white rounded-lg text-2xl transition ${colors[color]} ${maxWidths[maxWidth]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
